import React,{ createRef, useState ,useEffect,useRef} from 'react'
import './Preview.css'
import aakar from "./aakar.jpg"
import aakar2 from "./aakar2.jpg"
import { useScreenshot } from 'use-react-screenshot'
import { saveAs } from 'file-saver'
// import sign from "./sign_new.jpg"
import sign from "./sign_new.jpg"

import sign1 from "./sign1.png"
import drskinfo from "./drskinfo.jpeg"
import autism2 from "./autism2.jpeg"
import doctorInfo from "./doctorInfo.jpeg"
import { FormGroup, Form, Input, Label, Button, Col,Alert ,Table,List} from 'reactstrap'
import Draggable from 'react-draggable'; // The default
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import NavbarComponent from './NavbarComponent'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {IconButton} from '@material-ui/core'
import SendIcon from '@mui/icons-material/Send';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircle from '@mui/icons-material/AddCircle'
import ShareIcon from '@mui/icons-material/Share'


const Preview = ({imageURL}) => {
 
    var componentRef = useRef();
    var state = JSON.parse(localStorage.getItem('state'));
    const prescription = JSON.parse(localStorage.getItem('prescription'));
    const general_medicines_selected = []
    const epilepsy_medicines_selected  = []
    const cognitive_medicines_selected  = []
    const control_medicines_selected  = []
    const gross_motor_medicines_selected = []
    const fine_motor_medicines_selected = []
    const constipation_controller_selected  = []
    const other_prescriptions = []
    // console.log(state)
    // var p_data = [];
    var prescription_string = ''

    const checkboxes = {
        "check1" : "Jumping/Running/Climbing/Roaming",
        "check2" : "Hitting/Hurting/Biting/Throwing",
        "check3" : "Stimming/Object Obsession",
        "check4" : "Indigestion/Constipation",
        "check5" : "Pointing/Imitation/Non-Verbal Communication",
        "check6" : "Vocabulary/Speech/Comprehension/Composition",
        "check7" : "Sleep"
    }

    for (let p of prescription){
        prescription_string = ' '+ p + '';
    }
    const { DOB, file,Visit_No,Name, Address,Age, Sex, Diagnosis,Goal,m_num,Receipt,Description,Note,ImageFile,EmptyTextArea1,ConsultationType,check1,check2,check3,check4,check5,check6,check7} = state;
    // const csvData = {...state,prescription:prescription}
     prescription.map((text) =>{
        const rawText = String(text || "");
        const normalizedText = rawText.toLowerCase();
        const medicineText = rawText
            .replace(/\s*_?(general_medicines|epilepsy_medicines|control_medicines|gross_motor_medicines|fine_motor_medicines|cognitive_medicines|constipation_controller)\s*$/i, "")
            .trim();

        if(normalizedText.includes("general_medicines") ){
            if (medicineText) general_medicines_selected.push(medicineText);
        }else if(normalizedText.includes("epilepsy_medicines") ) {
            if (medicineText) epilepsy_medicines_selected.push(medicineText);
        }
        else if(normalizedText.includes("control_medicines") ) {
            if (medicineText) control_medicines_selected.push(medicineText);
        }
        else if(normalizedText.includes("gross_motor_medicines") ) {
            if (medicineText) gross_motor_medicines_selected.push(medicineText);
        }
        else if(normalizedText.includes("fine_motor_medicines") ) {
            if (medicineText) fine_motor_medicines_selected.push(medicineText);
        }
        else if(normalizedText.includes("cognitive_medicines") ) {
            if (medicineText) cognitive_medicines_selected.push(medicineText);
        }
        else if(normalizedText.includes("constipation_controller") ) {
            if (medicineText) constipation_controller_selected.push(medicineText);
        }else {
            if (medicineText) other_prescriptions.push(medicineText)
        }
     })
   
    const saveToMail = () => {
        const input = document.getElementById("Page");
        html2canvas(input, { logging: true, letterRendering: 1, useCORS: true, }).then(canvas => {
            const imgWidth = 0;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            const imgData = canvas.toDataURL('img/png');
            console.log(input)
            console.log(imgData)
            console.log(typeof(imgData))
            axios({
                method: 'post',
                // url: 'https://aakar-clinic-02.onrender.com/prescription',
                url: 'https://aakar-clinic-02.onrender.com/saveimg',
                data:  {'base64String':imgData,'name':state.Name}, // you are sending body instead
                headers: {
                'Content-Type': 'application/json'
                }, 
              })
              alert("Email Saved to Mail Succesfully")

              console.log("save Img post req sent !")    
        })
    }
    const exportPDF = () => {
        const input = document.getElementById("Page");
        html2canvas(input, {
            logging: false,
            letterRendering: true,
            useCORS: true,
            backgroundColor: "#ffffff",
            scale: 3
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/png', 1.0);
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
            const renderWidth = canvas.width * ratio;
            const renderHeight = canvas.height * ratio;
            const x = (pageWidth - renderWidth) / 2;
            const y = (pageHeight - renderHeight) / 2;
            pdf.addImage(imgData, 'PNG', x, y, renderWidth, renderHeight, undefined, 'FAST');
            pdf.save(`${getSafeFileName()}.pdf`);
        });
    }

    const getSafeFileName = () => {
        const patientName = String(Name || "").trim();
        const visitNumber = String(Visit_No || "").trim();
        const baseName = patientName || visitNumber || "Prescription";
        return baseName.replace(/[^a-zA-Z0-9 _-]/g, "").replace(/\s+/g, "_");
    }

    const ref = createRef(null)
    const [image, takeScreenshot] = useScreenshot();
    var isSS = false;
    const getImage = () => {
        html2canvas(ref.current, {
            logging: false,
            useCORS: true,
            backgroundColor: "#ffffff",
            scale: 3
        }).then(canvas => {
            const imageData = canvas.toDataURL('image/png', 1.0);
            const previewImage = document.getElementById('screenshot-preview-image');
            if (previewImage) previewImage.src = imageData;
            const link = document.createElement('a');
            link.download = `${getSafeFileName()}.png`;
            link.href = imageData;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    const [textAreaStyle,setTextAreaStyle] = useState({width:"100%",border:"none",padding:"0%",margin:"0%"});
     useEffect (() => {
        var count = JSON.parse(localStorage.getItem('counter') || 0);
      
        localStorage.setItem('counter', ++count)
        console.log(JSON.parse(localStorage.getItem('counter')))
    },[window.unload])
    
    let  filteredCheckBoxes= [];
    const [finalchecks,setFinalchecks] = useState([]);
    useEffect(() => {
        // console.log(Prescription)
        // const csvDOB = DOB.toString();
        // const csvPrescription = prescription.toString();
    
        // const csvStfilteredCheckBoxesate = {
        //     csvDOB,Visit_No,Name, csvPrescription,Address,Age, Sex, Diagnosis,Goal,MobileNo,Receipt,Description
        // }
        // const prescription_d = JSON.parse(localStorage.getItem('prescription_data'));
        // prescription_d.push(csvState);
        // localStorage.setItem('prescription_data', JSON.stringify(prescription_d))
        // p_data = prescription_d;
        state.Prescription[0] = prescription_string;
        if(check1) { filteredCheckBoxes.push(checkboxes.check1)}
        if(check2) { filteredCheckBoxes.push(checkboxes.check2)}
        if(check3) { filteredCheckBoxes.push(checkboxes.check3)}
        if(check4) { filteredCheckBoxes.push(checkboxes.check4)}
        if(check5) { filteredCheckBoxes.push(checkboxes.check5)}
        if(check6) { filteredCheckBoxes.push(checkboxes.check6)}
        if(check7) { filteredCheckBoxes.push(checkboxes.check7)}
        setFinalchecks(filteredCheckBoxes);
        if(window.innerWidth > 900){
            setTextAreaStyle({width:"100%",border:"none",padding:"0%",margin:"0%",overflow:"hidden !important",maxHeight:"200px"})
        } 
        else if(window.innerWidth  < 900 &&  window.innerWidth > 510){  
            setTextAreaStyle({width:"100%",border:"none",padding:"0%",margin:"0%",overflow:"hidden !important",maxHeight:"400px"});
        }

    })
    function getAge(dob) {
          
        if(dob == ''){
            return Age;
        }   
        var dobYear = dob.slice(0,4)-1900;  
        var dobMonth = dob.slice(5,7);  
        var dobDate = dob.slice(8,10);  
 
          
        //get the current date from the system  
        var now = new Date();  
        //extract the year, month, and date from current date  
        var currentYear = now.getYear();  
        var currentMonth = now.getMonth()+1;  
        var currentDate = now.getDate();  
          
        
        //declare a variable to collect the age in year, month, and days  
        var age = {};  
        var ageString = "";  
        
        //get years  
       var yearAge = currentYear - dobYear;  


        //get months  
        if (currentMonth >= dobMonth)  
          //get months when current month is greater  
          var monthAge = currentMonth - dobMonth;  
        else {  
          yearAge--;  
          var monthAge = 12 + currentMonth - dobMonth;  
        }  

      
        //get days  
        if (currentDate >= dobDate)  
          //get days when the current date is greater  
          var dateAge = currentDate - dobDate;  
        else {  
          monthAge--;  
          var dateAge = 31 + currentDate - dobDate;  
      
          if (monthAge < 0) {  
            monthAge = 11;  
            yearAge--;  
          }  
        }  
        //group the age in a single variable  
        age = {  
        years: yearAge,  
        months: monthAge,  
        days: dateAge  
        };  
            
            
        if ( (age.years > 0) && (age.months > 0) && (age.days > 0) )  
           ageString = age.years + " years, " + age.months + " months, and " + age.days + " days old.";  
        else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) )  
           ageString = "Only " + age.days + " days old!";  
        //when current month and date is same as birth date and month  
        else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) )  
            ageString = age.years +  " years old. Happy Birthday!!";  
        else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) )  
            ageString = age.years + " years and " + age.months + " months old.";  
        else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) )  
            ageString = age.months + " months and " + age.days + " days old.";  
        else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) )  
            ageString = age.years + " years, and " + age.days + " days old.";  
        else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) )  
            ageString = age.months + " months old.";  
        //when current date is same as dob(date of birth)  
        else ageString = "";
        return ageString ;
    }
    
    const downloadImage = () => {
        saveAs(image, 'image.jpg') // Put your image url here.
      }
    //  var vis = {visibility:"hidden"}
    
    function ChangeFormateDate(date){
        var p = date.split(/\D/g)
        return [p[2],p[1],p[0] ].join("/")
    }
    
    var x =  moment().format('LLLL');
    var displayDate = x;
      
    var age_c  = getAge(DOB); 
    if(age_c == ""){
            age_c = Age; 
    }

    const [showPreview,setShowPreview] = useState(false)
    const [personToMail,setPersonToMail] = useState('')
    const [showMailBox,setShowMailBox] = useState(false)
    const showEmailInput = () => {
        setShowMailBox(true);
    }
    const handleChangePersonToMail = (e) => {
        console.log(e.target.value)
        setPersonToMail(e.target.value)
    }
    const  dataURLtoFile = (dataurl, filename)  => {
        console.log(dataurl)
        var arr = dataurl?.split(',')
        console.log(arr)
        var mime = arr[0]?.match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr?.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr?.charCodeAt(n);
        }
        
        return new File([u8arr], filename, {type:mime});
    }

      const sendMailToPerson = () => {
        setShowMailBox(false);
        const input = document.getElementById("Page");
        html2canvas(input, { logging: true, letterRendering: 1, useCORS: true, }).then(canvas => {
            const imgWidth = 0;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            const imgData = canvas.toDataURL('img/png');
            console.log(input)
            console.log(imgData)
            console.log(typeof(imgData))
            axios({
                method: 'post',
                // url: 'https://aakar-clinic-02.onrender.com/prescription',
                url: 'https://aakar-clinic-02.onrender.com//saveimg',
                data:  {'base64String':imgData,'name':Name,'mobile_no':m_num,'personToMail':personToMail}, // you are sending body instead
                headers: {
                'Content-Type': 'application/json'
                }, 
              }) 
              alert("Email sent to " + personToMail + " Succesfully")
              console.log("save Img post req sent !")    
        })
      }
    // const [imgData,setImageData] = useState('')
    var imgData = '';
    const handleShare = async () => {
        const input = document.getElementById("Page");
      
        html2canvas(input, { logging: true, letterRendering: 1, useCORS: true, }).then(canvas => {
            const imgWidth = 0;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            // setImageData(canvas.toDataURL('img/png'));
            imgData = canvas.toDataURL('img/png');
            console.log(imgData)
        })
        // alert(JSON.stringify(imgData))
       
        console.log(imgData)
        const file = dataURLtoFile(imgData,"prescription.png");
        // const file = dataURItoBlob(imgData);
        console.log(file)
        const data = {
            files: [
                file
            ],
            title: "Prescription",
            text: "Aakar Clinic"
        };

        try {
        if (!navigator.canShare(data)) {
           console.log("Can't share");
        }
        await navigator.share(data);
        // alert("Sharing..")
        } catch (err) {
            console.error(err);
        }
  };
    return (
        <>
        <NavbarComponent />
        <div className="prescription-view" >
        {/* <CsvDownloadButton  data={[state]}/> */}
        {/* <Link to="/prescription">TO Prescription</Link> */}
        
        
        <section className="screenshot-capture" style={{padding:"4px"}}>    
                <br />
                <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
                <Button color="primary" onClick={getImage} style={{height:"35px",margin:"5px"}}>
                        Take SS
                </Button>
                <Button color='danger' onClick={exportPDF} style={{height:"35px",margin:"5px"}}>Print</Button>
                <Button onClick={saveToMail} style={{height:"35px",margin:"5px"}} color="warning">E-Mail Me</Button>
                <Button onClick={showEmailInput} style={{height:"35px",margin:"5px"}}>Mail To</Button> 
                {showMailBox ? (
                    <>
                    <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
                    <Input type="text" name="personToMail" style={{width:200}}placeholder="Email To .." onChnage={handleChangePersonToMail}/>
                    <IconButton onClick={sendMailToPerson}><SendIcon/></IconButton>
                    </div>
                    </>

                ):(<></>)}
                <IconButton onClick={handleShare}><ShareIcon fontSize="large" color="primary" /></IconButton>

                <IconButton><Link to="/prescription" target="_blank"><AddCircle /></Link></IconButton>
                </div>
                 <br />

             
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",color:"white",fontSize:"18px"}}>
                
                <hr />
                <div style={{textAlign:"center"}}>
                
                <img id="screenshot-preview-image" style={{width:"100px",height:"140px",objectFit:"contain",position:"relative",border:"1px solid orange",borderRadius:"10px",backgroundColor:"white"}} src={image || ""} alt="Prescription Screenshot Preview" />
            
            </div>
           
            </div>
            </section>
            <section  style={{padding:"12px"}} ref={el => (componentRef = el)}>
                    <section id = "Page"  className ="page"  ref={ref }   >

                    <table className="clinic-header-table" aria-label="Clinic and doctor logos">
                        <tbody>
                            <tr>
                                <td className="clinic-logo-cell">
                                    <img src={aakar} className="aakar-logo header-clinic-logo" alt="Aakaar Clinic" />
                                </td>
                                <td className="doctor-logo-cell">
                                    <img src={aakar2} className="header-doctor-logo" alt="Dr. Santosh V. Kondekar" />
                                </td>
                                <td className="camera-logo-cell">
                                    { (file !== null && file !== undefined) || imageURL ? (
                                        <img
                                            src={file !== null && file !== undefined ? file : imageURL}
                                            className="header-camera-logo"
                                            alt="Patient"
                                        />
                                    ) : null }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                <br />

                
                <section class="doctor-info" >
                    <div class="doctor-name">
                    <span>Dr Santosh <surname>Kondekar</surname></span>
                    <p>Reg N:86230 ,MD DNB DCH FCPS FAIMER</p>
                    </div>
                    <div class="profession">
                    <span>Neuro-Developmental <surname>Pediatrician</surname></span>
                    <p>aakaarclinic@gmail.com <num>M:9869405747</num></p>
                    </div>
                </section>

                <section style={{ backgroundImage: `url(${sign1})`}}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={0} >
                        <Grid item xs={3}  style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",borderTop:"1px solid grey",fontSize:"12px"}}>
                            <b > &nbsp;&nbsp;Date</b> 
                        </Grid>
                      
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeftColor:"1px solid grey",borderTop:"1px solid grey",fontSize:"12px"}}>
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{displayDate} 
                        </Grid>
                       
                        <Grid item xs={3}  style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}}>
                            <b> &nbsp;&nbsp;Visit_No </b>   
                        </Grid>
                        <Grid item xs={9}  style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}}>
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{Visit_No}  
                        </Grid>
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;ID </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{m_num}  
                        </Grid>
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;Age</b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{age_c}  
                        </Grid>
                       
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;Name </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{Name}  
                        </Grid>
                       
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;DOB </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{DOB}  
                        </Grid>
                       
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;Sex </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderRight:"1px solid grey",borderLeft:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{Sex}  
                        </Grid>
                       
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderLeft:"1px solid grey",borderRight:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;Address </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderLeft:"1px solid grey",borderRight:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{Address}  
                        </Grid>
                       
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderLeft:"1px solid grey",borderRight:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;Diagnosis </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderLeft:"1px solid grey",borderRight:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;{Diagnosis}  
                        </Grid>
                       
                        <Grid item xs={3} style={{borderBottom:"1px solid grey",borderLeft:"1px solid grey",borderRight:"1px solid grey",fontSize:"12px"}} >
                            <b > &nbsp;&nbsp;Goal for next month </b>   
                        </Grid>
                        <Grid item xs={9} style={{borderBottom:"1px solid grey",borderLeft:"1px solid grey",borderRight:"1px solid grey",fontSize:"12px"}} >
                        &nbsp;&nbsp; &nbsp;&nbsp;{Goal}  
                        </Grid>
                        <Grid item xs={12} style={{fontSize:"12px"}} >
                        &nbsp;&nbsp; {EmptyTextArea1}  
                        </Grid>
                    </Grid>
                </Box>
            
               
                <hr/>
                </section>
                <section >
                    <div style={{fontSize:"10px"}}><b>Current Issues : </b>
                
                    </div>
                    <ol>
                        {finalchecks?.map((c)=>{
                            return(
                                <li style={{fontSize:"9px"}}>{c}</li>
                            )
                        })}
                   </ol>
                 </section>
                <section style={{ backgroundImage: `url(${sign1})`}}>
                {
                    prescription.length === 0 ? (
                        <></>
                    )  : (
                       <>
                            
                        <div ><b>Prescription : </b></div>
                        <b><p style={{fontSize:"10px"}}> (Join parent support group and read more about Goal Directed Cognitive Approach at <a href="http://www.neuropediatrician.com">www.neuropediatrician.com</a>)</p></b>
                            
                          {
                            general_medicines_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>General Medicines </p></b>) : <></>
                          }
                           <ul>
                           {general_medicines_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>

                           {
                            epilepsy_medicines_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Epilepsy Medicines </p></b>) : <></>
                          }
                           <ul>
                           {epilepsy_medicines_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>
                           {
                            control_medicines_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Control Medicines </p></b>) : <></>
                          }
                           <ul>
                           {control_medicines_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>
                           {
                            cognitive_medicines_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Cognitive Medicines </p></b>) : <></>
                          }
                           <ul>
                           {cognitive_medicines_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>
                           {
                            fine_motor_medicines_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Fine Motor Medicines </p></b>) : <></>
                          }
                           <ul>
                           {fine_motor_medicines_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>
                           {
                            gross_motor_medicines_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Gross Motor Medicines </p></b>) : <></>
                          }
                           <ul>
                           {gross_motor_medicines_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>
                           {
                            constipation_controller_selected?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Constipation Controller </p></b>) : <></>
                          }
                           <ul>
                           {constipation_controller_selected?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>
                           
                           {
                             other_prescriptions?.length > 0 ? (<b><p style={{fontSize:"9px"}}>Other Medicines </p></b>) : <></>
                          }
                           <ul>
                           {other_prescriptions?.map((p)=>{
                                return <><li>{p}</li></>
                           })}
                           </ul>


                           {/* else if(p.includes("_epilepsy_medicines_selected")){
                                p=p.replace("_epilepsy_medicines","")
                                return <><b><p style={{fontSize:"9px"}}>Epilepsy Medicines </p></b><li>{p}</li></>
                              }else if(p.includes("_control_medicines")){
                                p=p.replace("_control_medicines","")
                                return <><b><p style={{fontSize:"9px"}}>Control Medicines </p></b><li>{p}</li></>
                              }else if(p.includes("_cognitive_medicines")){
                                p=p.replace("_cognitive_medicines","")
                                return <><b><p style={{fontSize:"9px"}}>Cognitive Medicines </p></b><li>{p}</li></>
                              }else if(p.includes("_fine_motor_medicines")){
                                p=p.replace("_fine_motor_medicines","")
                                return <><b><p style={{fontSize:"9px"}}>Fine Motor Medicines </p></b><li>{p}</li></>
                              }
                              else if(p.includes("_constipation_controller")){
                                p=p.replace("_constipation_controller","")
                                return <><b><p style={{fontSize:"9px"}}>Constipation Medicines </p></b><li>{p}</li></>
                              } */}
                       </>
                    )
                }
                </section>
                <section  style={{fontSize:"10px",marginTop:"8px"}}>
                    <p><b>{state.ShowTherapyRecommendation !== false ? "DAILY OCCUPATIONAL THERAPY, SPEECH THERAPY AND REMEDIAL EDUCATION SESSIONS ARE RECOMMENDED IN THIS CASE" : ""}</b></p>
                    <p><b><u>THIS IS A PRESCRIPTION ISSUED AFTER AN {ConsultationType ? ConsultationType.toUpperCase() : "OFFLINE"} CONSULTATION</u></b></p>
                </section>
                <section  style={{fontSize:"9px !important",backgroundImage: `url(${sign1})`}} >
                      {/* <Draggable>     */}
                    <b style={{fontSize:"9px"}}>Note</b>
                    <p  style={{fontSize:"10px"}}>
                       <b>{Note }</b> 
                   </p>
                   <p  style={{fontSize:"10px"}}>
                       <b>{Description}</b> 
                   </p>

                   {/* </Draggable>      */}
                    <br /> 
                    <table className="prescription-footer-table">
                        <tbody>
                            <tr>
                                <td className="footer-details-cell">
                                    <p style={{fontFamily:"'Schoolbell', arial, serif",marginBottom:"6px"}}><b>Date : </b>{(JSON.stringify(new Date()).slice(1,11))}</p>
                                    <p style={{fontSize:"10px",marginBottom:"0"}}><strong>Payment Receipt No. : </strong> W-{JSON.parse(localStorage.getItem('counter')) + 2000}/2023</p>
                                </td>
                                <td className="footer-followup-cell">
                                    <p className="followup-box"><b>Follow up after 21 days between {new Date(new Date().setDate(new Date().getDate() + 21)).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} - {new Date(new Date().setDate(new Date().getDate() + 24)).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</b></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table className="prescription-signature-table">
                        <tbody>
                            <tr>
                                <td className="signature-cell"><img className="fixed-signature-image" src={sign} alt="Signature" /></td>
                                <td className="stamp-cell"><img className="fixed-stamp-image" src={drskinfo} alt="Doctor stamp" /></td>
                                <td className="footer-auto-cell"><img className="auto-footer-image" src={autism2} alt="Cognitive approach footer" /></td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                     <Grid container spacing={2}>
                      
                        <Grid item xs={6}>
                            {/* <Draggable> */}
                                {/* <section>
                                
                                    <p><strong>Payment Receipt No. : </strong> W-{JSON.parse(localStorage.getItem('counter'))+2000}/2023</p>
                                    {   
                                        (Receipt == '') ? (<div></div>) : 
                                        (<p><strong>Payment Receipt :  </strong> {Receipt}</p>) 
                                    }
                                </section> */}
                            {/* </Draggable> */}
                          
                        </Grid>
                                          
                        {/* <Grid item xs={6}>
                            <Draggable>
                            <img  style={{height:"75px",margin:"0px !important",padding:"0px !important"}}  src={sign} alt='sign' />
                            </Draggable>
                        </Grid> */}
                     </Grid>
    
    
                </section>
                    </section>
            </section >
        </div>
        </>
    )}
export default Preview